"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactRedux = require("react-redux");
var _r10SourceLibrary = require("r10-source-library");
var _constants = require("../constants");
var _useTranslation = _interopRequireDefault(require("../hooks/useTranslation"));
var _WrapByDataAttributes = _interopRequireDefault(require("../utils/WrapByDataAttributes"));
var _useConfig2 = _interopRequireDefault(require("../hooks/useConfig"));
var _getValueFromJson = _interopRequireDefault(require("../utils/getValueFromJson"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/* eslint-disable */

var PlanHeader = function PlanHeader() {
  var t = (0, _useTranslation.default)();
  var _useConfig = (0, _useConfig2.default)(),
    _useConfig$activePlan = _useConfig.activePlanSchema,
    _useConfig$activePlan2 = _useConfig$activePlan === void 0 ? {} : _useConfig$activePlan,
    _useConfig$activePlan3 = _useConfig$activePlan2.planHeaderSection,
    _useConfig$activePlan4 = _useConfig$activePlan3 === void 0 ? {} : _useConfig$activePlan3,
    planStatus = _useConfig$activePlan4.planStatus,
    totalPrice = _useConfig$activePlan4.totalPrice,
    discountPrice = _useConfig$activePlan4.discountPrice,
    planName = _useConfig$activePlan4.planName;
  var activePlanDetails = (0, _reactRedux.useSelector)(function (state) {
    return state[_constants.PKG_NAME].activePlanDetails;
  });
  var status = "".concat((0, _getValueFromJson.default)(activePlanDetails, planStatus));
  var name = "".concat((0, _getValueFromJson.default)(activePlanDetails, planName));
  var price = "".concat((0, _getValueFromJson.default)(activePlanDetails, totalPrice));
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.GridRow, {
    marginBottom: 4,
    justify: status ? 'between' : 'end',
    align: "center"
  }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.GridColumn, {
    col: 6
  }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.GridRow, {
    justify: "start"
  }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Heading, {
    dataAttributes: {
      'data-testid': 'plan-card-name'
    },
    level: 3,
    weight: 1,
    noMargin: true
  }, name))), status && /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.GridColumn, {
    col: 6
  }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.GridRow, {
    justify: "end"
  }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Pill, {
    dataAttributes: {
      'data-testid': 'plan-card-status'
    },
    text: t("".concat(status)),
    state: "success",
    id: "pill-id",
    dataSelectorPrefix: "pill"
  })))), price && /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.GridRow, {
    marginBottom: 4,
    direction: "column"
  }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Heading, {
    dataAttributes: {
      'data-testid': 'plan-price'
    },
    level: 4,
    weight: 3
  }, price), /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Spacing, {
    spacingLevel: {
      bottom: 6
    }
  })));
};
var _default = PlanHeader;
exports.default = _default;